/* eslint-disable */
import React, { useState, useEffect, useRef, useContext } from 'react';
import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
  Slide,
  Checkbox,
  ClickAwayListener,
  Popover,
  Snackbar,
  FormControl,
  Select,
  MenuItem,
  Switch,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useStyles from '../../Main.style';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Formik } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import useForms from '../../../../hooks/useForms';
import usePractice from '../../../../hooks/usePractice';
import FilterListIcon from '@material-ui/icons/FilterList';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import blankIMage from '../../../../assets/images/TablePlaceholder.png';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CloseIcon from '@material-ui/icons/Close';
import { debounce } from 'lodash';
import { FOCUS_MODE_EVENTS } from '../../../../constants/actionTypes';
import { FocusModeContext } from '../../../../contexts/focusModeContext';
import SortIcon from '@material-ui/icons/Sort';
import { formatToCurrency, getLoggedInUserData } from '../../../../utils/Helper';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Alert } from '@material-ui/lab';
import {
  ALL_SAVED_SEARCH_WARNING,
  DELETE_SAVED_SEARCH_WARNING,
} from '../../../../constants/deleteMessaageConstants';
import DeleteOption from '../../../../components/DeleteOption';
import {
  DEPARTMENT_ADMIN,
  DEPARTMENT_CORPORATION,
} from '../../../../constants/departmentConstants';

const FinancialAnalysisTab = ({ allFinancialCompensationData }) => {
  const classes = useStyles();

  const {
    getCountry,
    fetchAllCellList,
    getCountriesCells,
    getDepartmentData,
    saveFilter,
    updateSavedFilter,
    getAllFilters,
    updateFilterName,
    deleteAllFilters,
    deleteSelectedFilter,
  } = usePractice();

  const loggedInUserData = getLoggedInUserData();

  const initialYearState = {
    year: new Date().getFullYear().toString(),
    id: null,
  };
  const theme = useTheme();
  const [totals, setTotals] = useState({});
  const [openFilter, setOpenFilter] = React.useState(false);
  const [fpData, setFpData] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [filteredFpData, setFilteredFpData] = useState([]);
  const [filteredFpDataClone, setFilteredFpDataClone] = useState([]);
  const [isApplyClicked, setIsApplyClicked] = useState(false);
  const [filteredColumnList, setFilteredColumnList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [selectedYear, setSelectedYear] = useState(initialYearState);
  const [cellListForFilter, setCellListForFilter] = useState([]);
  const [copyCellListForFilter, setCopyCellListForFilter] = useState([]);
  const [deptListForFilter, setDeptListForFilter] = useState([]);
  const [yearListForFilter, setYearListForFilter] = useState([]);
  const [selectedSearchId, setSelectedSearchId] = useState(null);
  const [selectedSearchIndex, setSelectedSearchIndex] = useState(null);
  const [selectedRankingField, setSelectedRankingField] = useState(null);
  const SelectAllFields = { label: 'Select All' };
  const [selectedFieldOption, setSelectedFieldOption] = useState([]);
  const [shouldLoadData, setShouldLoadData] = useState(false);
  const SelectAllCountries = { countryTitle: 'Select All' };
  const [selectedCountryOption, setSelectedCountryOption] = useState([]);

  const SelectAllCells = { cellTitle: 'Select All' };
  const [selectedCellOption, setSelectedCellOption] = useState([]);
  const [cellsByCountryIndicator, setCellsByCountryIndicator] = useState({});

  const SelectAllDepartments = { department: 'Select All' };
  const [selectedDepartmentOption, setSelectedDepartmentOption] = useState([]);
  const [filterSubmitted, setFilterSubmitted] = useState([]);
  const { getFinParamsUsers } = useForms();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [searchAnchorEl, setSearchAnchorEl] = React.useState(null);
  const [rankingSubmenuOpen, setRankingSubmenuOpen] = useState(false);
  const popoverRef = useRef(null);
  const [rankDataByWidth, setRankDataByWidth] = React.useState(null);
  const [savedSearches, setSavedSearches] = useState([]);
  const [filterEditMode, setFilterEditMode] = useState(false);
  let reportData = [];
  let finDataAll = [];

  const [openFilterName, setOpenFilterName] = React.useState(false);
  const [openFilterRename, setOpenFilterRename] = React.useState(false);
  const [openFilterValidation, setOpenFilterValidation] = React.useState(false);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = React.useState(false);
  const [filterSelectedUpdate, setFilterSelectedUpdate] = React.useState({});
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [openCountry, setOpenCountry] = useState(false);
  const [openCountryClick, setOpenCountryClick] = React.useState(false);
  const [selectedSortItem, setSelectedSortItem] = React.useState({});
  const [scrollTop, setScrollTop] = useState(0);

  const isFinAnalysisVisible =
    loggedInUserData?.department?.departmentTitle === DEPARTMENT_CORPORATION ||
    loggedInUserData?.department?.departmentTitle === DEPARTMENT_ADMIN ||
    loggedInUserData.roleId == 1;
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [isFocusMode, dispatchIsFocusMode] = useContext(FocusModeContext);
  const [showSnackBarErr, setShowSnackBarErr] = useState(false);
  const pageFpSizeOptions = [10, 20, 50, 100];

  const [currentFpPage, setCurrentFpPage] = useState(1);
  const [pageFpSize, setFpPageSize] = useState(20);
  const [selectedMonthOption, setSelectedMonthOption] = useState([]);
  const [filterOptionsUpdated, setFilterOptionsUpdated] = useState(false);

  const periodOptions = [
    { label: 'Full Year', value: 'fullYear' },
    { label: 'January - June', value: 'janJune', disabled: true },
    { label: 'July - December', value: 'julyDec', disabled: true },
    { label: 'Q1', value: 'q1', disabled: true },
    { label: 'Q2', value: 'q2', disabled: true },
    { label: 'Q3', value: 'q3', disabled: true },
    { label: 'Q4', value: 'q4', disabled: true },
  ];

  const handleRankingMouseEnter = () => {
    setRankingSubmenuOpen(true);
  };

  const handleRankingMouseLeave = () => {
    setRankingSubmenuOpen(false);
  };

  const handleFpPageChange = (newFpPage) => {
    setCurrentFpPage(newFpPage);
  };

  const handleFpPageSizeChange = (newFpPageSize) => {
    setFpPageSize(Number(newFpPageSize?.target?.value));
    setCurrentFpPage(1);
  };

  const startFpIndex = (currentFpPage - 1) * pageFpSize;
  const endFpIndex = startFpIndex + pageFpSize;
  let displayedFpData = selectedSortItem.sortField
    ? filteredFpData.slice(startFpIndex, endFpIndex)
    : filteredFpDataClone.slice(startFpIndex, endFpIndex) || [];
  const handleSnackBarClose = () => {
    setShowSnackBarErr(false);
  };

  const redirectPage = (rowData) => {
    window.open('#/app/view-employee/' + rowData?.employeeId + '/' + rowData?.countryId, '_blank');
  };

  const handleFocusModeClick = () => {
    if (!isFocusMode.isFocusMode) {
      enterFullscreen();
    } else {
      exitFullscreen();
    }
    dispatchIsFocusMode({ type: FOCUS_MODE_EVENTS.SUCCESS, payload: !isFocusMode.isFocusMode });
  };

  const handleEditMode = () => {
    setFilterEditMode((prev) => !prev);
  };

  const enterFullscreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };

  const handleFullscreenChange = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    ) {
      // User is in fullscreen mode
      dispatchIsFocusMode({ type: FOCUS_MODE_EVENTS.SUCCESS, payload: true });
    } else {
      // User has exited fullscreen mode
      dispatchIsFocusMode({ type: FOCUS_MODE_EVENTS.SUCCESS, payload: false });
    }
  };
  const handleToggleColumn = (field) => {
    if (field) {
      setHiddenColumns((prevHiddenColumns) => {
        // hide column functionality
        const updatedHiddenColumns = prevHiddenColumns.includes(field)
          ? prevHiddenColumns.filter((column) => column !== field)
          : [...prevHiddenColumns, field];

        for (let i = 0; i < filteredColumnList.length; i++) {
          filteredColumnList[i].hidden = updatedHiddenColumns.includes(filteredColumnList[i].field);
        }
        return updatedHiddenColumns;
      });
    } else {
      setHiddenColumns([]);

      for (let i = 0; i < filteredColumnList.length; i++) {
        filteredColumnList[i].hidden = false;
      }
    }
  };

  const clearAll = () => {
    setSelectedCountryOption([]);
    setSelectedCellOption([]);
    setSelectedDepartmentOption([]);
    setSelectedFieldOption([]);
    setSelectedMonthOption([]);
    setOpenFilter(false);
    setIsApplyClicked(false);
    setSelectedSortItem({});
    setSelectedYear(initialYearState);
    setLoaded(false);
    setShouldLoadData(true);
  };

  // useEffect that fires when shouldLoadData becomes true.
  useEffect(() => {
    if (shouldLoadData) {
      loadFpData(initialYearState);
      setShouldLoadData(false);
    }
  }, [shouldLoadData]);
  const containerStyle = {
    maxWidth: '100%',
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  };

  const imageStyle = {
    maxWidth: '310px',
    maxHeight: '100%',
  };

  const [filterName, setFilterName] = useState('');
  const [filterRename, setFilterRename] = useState('');
  const [isFilterNameValid, setFilterNameValid] = useState(true);
  const [isFilterRenameValid, setFilterRenameValid] = useState(true);

  const fieldOptions = [
    { label: 'Salaries', value: 'salary' },
    { label: 'Bonuses', value: 'bonuses' },
    { label: 'Commissions', value: 'commissions' },
    { label: 'Benefits', value: 'benefits' },
    { label: 'Expense Report', value: 'expenseReport' },
    { label: 'Ranking', value: 'ranking' },
  ];

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const [anchorMts, setAnchorMts] = React.useState([]);
  const [anchorPositions, setAnchorPositions] = React.useState([]);

  const handleMtMenuClick = (event, columnIndex) => {
    const updatedAnchorMts = [...anchorMts];
    updatedAnchorMts[columnIndex] = event.currentTarget;
    setAnchorMts(updatedAnchorMts);

    const updatedAnchorPositions = [...anchorPositions];
    updatedAnchorPositions[columnIndex] = { top: event.pageY - scrollTop, left: event.pageX };

    setAnchorPositions(updatedAnchorPositions);
  };

  const handleToggleOpen = (source) => {
    if (source == 'open') {
      setOpenCountry(true);
    } else if (source == 'close') {
      setOpenCountry(false);
    } else {
      setOpenCountry(true);
    }
  };

  const handleMtMenuClose = (columnIndex) => {
    const updatedAnchorMts = [...anchorMts];
    updatedAnchorMts[columnIndex] = null;
    setAnchorMts(updatedAnchorMts);

    const updatedAnchorPositions = [...anchorPositions];
    updatedAnchorPositions[columnIndex] = null;
    setAnchorPositions(updatedAnchorPositions);
  };

  const calculateRank = (item, field, filteredData) => {
    let rankingFilteredFpData = filteredData?.length ? [...filteredData] : [];
    let obj = fieldOptions.find((o) => o.value === field);
    obj?.label.toLowerCase() != 'ranking' && setSelectedRankingField(obj?.label);
    rankingFilteredFpData = sortFloatValues(rankingFilteredFpData, field, 'sort down');

    rankingFilteredFpData.forEach((obj, index) => {
      if (!obj.ranking) {
        obj.ranking = {};
      }
      obj.ranking.rankValue = index + 1;
    });
    setFilteredFpData(rankingFilteredFpData);
  };

  const handleMenuItemClick = debounce((item, field, columnIndex) => {
    if (columnIndex === 0) {
      calculateRank(item, field, filteredFpData);
    }

    if (item.toLowerCase() === 'show ranking') {
      calculateRank(item, field, filteredFpData);
    }

    if (item.toLowerCase() === 'hide column') {
      handleToggleColumn(field);
    }

    if (item.toLowerCase() == 'sort up' || item.toLowerCase() == 'sort down') {
      if (
        selectedSortItem?.sortType &&
        columnIndex === selectedSortItem?.sortColumnIndex &&
        item.toLowerCase() === selectedSortItem?.sortType
      ) {
        setSelectedSortItem({});
      } else {
        setSelectedSortItem({
          sortType: item.toLowerCase(),
          sortField: field,
          sortColumnIndex: columnIndex,
        });

        let sortItems = [...filteredFpData];
        if (item.toLowerCase() == 'sort up') {
          if (
            field === 'salary' ||
            field === 'bonuses' ||
            field === 'commissions' ||
            field === 'benefits' ||
            field === 'expenseReport' ||
            field === 'ranking' ||
            field === 'total'
          ) {
            if (field === 'ranking') {
              sortItems.sort(function (a, b) {
                return Number(a?.ranking?.rankValue) - Number(b?.ranking?.rankValue);
              });
            } else {
              sortItems = sortFloatValues(sortItems, field, 'sort up');
            }
          } else {
            sortItems.sort((a, b) => {
              return compareNames(a[field], b[field]);
            });
          }

          setFilteredFpData(sortItems);
        } else if (item.toLowerCase() == 'sort down') {
          if (
            field === 'salary' ||
            field === 'bonuses' ||
            field === 'commissions' ||
            field === 'benefits' ||
            field === 'expenseReport' ||
            field === 'ranking' ||
            field === 'total'
          ) {
            if (field === 'ranking') {
              sortItems.sort(function (a, b) {
                return Number(b?.ranking?.rankValue) - Number(a?.ranking?.rankValue);
              });
            } else {
              sortItems = sortFloatValues(sortItems, field, 'sort down');
            }
          } else {
            sortItems.sort((a, b) => {
              return compareNames(a[field], b[field]);
            });
          }

          setFilteredFpData(sortItems);
        }
      }
    }

    if (item.toLowerCase() === 'unhide columns') {
      handleToggleColumn();
    }
    handleMtMenuClose(columnIndex);
  }, 100);

  const compareNames = (nameA, nameB) => {
    if (nameA === undefined && nameB === undefined) {
      return 0;
    }
    if (nameA === undefined) {
      return -1;
    }
    if (nameB === undefined) {
      return 1;
    }
    return nameA.localeCompare(nameB);
  };

  function formatNumberWithPrecision(value, precision) {
    return parseFloat(value).toFixed(precision);
  }

  const sortFloatValues = (sortItems, field, sortType) => {
    if (!selectedRankingField) {
      let obj = fieldOptions.find((o) => o.value === field);
      setSelectedRankingField(obj?.label);
    }
    sortItems.sort((a, b) => {
      const strA = a[field];
      const strB = b[field];

      // Check if either strA or strB is NaN (not a number)
      const isStrANaN = isNaN(parseFloat(strA));
      const isStrBNaN = isNaN(parseFloat(strB));

      // Handle NaN cases first
      if (isStrANaN && isStrBNaN) {
        return 0; // Both values are NaN, so they are considered equal
      } else if (isStrANaN) {
        // strA is NaN, move it to the end regardless of sort type
        return 1;
      } else if (isStrBNaN) {
        // strB is NaN, move it to the end regardless of sort type
        return -1;
      }

      // At this point, both strA and strB are numeric values represented as strings

      const numA = parseFloat(String(strA)?.replace(/[^\d.-]/g, ''));
      const numB = parseFloat(String(strB)?.replace(/[^\d.-]/g, ''));

      const precision = 3; // Set the desired precision here

      if (sortType === 'sort up') {
        return (
          parseFloat(formatNumberWithPrecision(numA, precision)) -
          parseFloat(formatNumberWithPrecision(numB, precision))
        );
      } else if (sortType === 'sort down') {
        return (
          parseFloat(formatNumberWithPrecision(numB, precision)) -
          parseFloat(formatNumberWithPrecision(numA, precision))
        );
      }

      // If the sortType is not 'sort up' or 'sort down', return 0 to indicate no change
      return 0;
    });

    return sortItems;
  };

  const headerComponent = (column, columnIndex) => {
    return (
      <>
        <If condition={columnIndex === 0 && column.field == 'ranking'}>
          {' '}
          {rankingSubmenuOpen && (
            <>
              <div
                style={{
                  position: 'absolute',
                  top: rankDataByWidth.top,
                  left: rankDataByWidth.left + rankDataByWidth.width,
                  backgroundColor: 'white',
                  borderRadius: '4px',
                  boxShadow:
                    '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
                  zIndex: '1301',
                  display: rankingSubmenuOpen ? 'block' : 'none',
                }}
              >
                {fieldOptions.map((field) => {
                  if (field.value !== 'selectAll' && field.value !== 'ranking') {
                    const searchValue = field?.value;
                    const exists = filteredColumnList.some((obj) => obj.field === searchValue);

                    return (
                      <>
                        <MenuItem
                          disabled={!exists}
                          onMouseEnter={handleRankingMouseEnter}
                          onMouseLeave={handleRankingMouseLeave}
                          onClick={() => handleMenuItemClick(field.value, field.value, 0)}
                        >
                          {field.label}
                        </MenuItem>
                      </>
                    );
                  }
                })}
              </div>
            </>
          )}
        </If>

        <Box
          display="flex"
          justifyContent={columnIndex === 0 ? 'flex-start' : 'center'}
          alignItems="center"
          width="100%"
        >
          <Box display="flex" alignItems="flex-start" flexDirection="column" gap={0.5}>
            {columnIndex === 0 && selectedRankingField && (
              <Box fontSize="0.75rem" fontWeight="500" whiteSpace="nowrap">
                {selectedRankingField[0].toUpperCase() +
                  selectedRankingField.slice(1).toLowerCase()}
              </Box>
            )}
            <Box display="flex" alignItems="center" flexWrap="nowrap" whiteSpace="nowrap">
              <Box whiteSpace="nowrap">{column?.title}</Box>

              <Button
                aria-controls={`menu-options-${column?.field}`}
                aria-haspopup="true"
                onClick={(event) => handleMtMenuClick(event, columnIndex)}
              >
                <ExpandMoreIcon />
              </Button>
              {selectedSortItem?.sortColumnIndex === columnIndex &&
              selectedSortItem?.sortType == 'sort up' ? (
                <>
                  <Box display="flex" className={classes.TableSortIcon}>
                    <SortIcon />
                  </Box>
                </>
              ) : selectedSortItem?.sortColumnIndex === columnIndex &&
                selectedSortItem?.sortType == 'sort down' ? (
                <>
                  <Box display="flex" className={classes.TableSortIconClicked}>
                    <SortIcon />
                  </Box>
                </>
              ) : (
                ''
              )}
            </Box>
          </Box>
        </Box>

        <Popover
          className={classes.MoreOptionsV2}
          id={`menu-options-${column?.field}`}
          anchorEl={anchorMts[columnIndex]}
          keepMounted
          open={Boolean(anchorMts[columnIndex])}
          onClose={() => handleMtMenuClose(columnIndex)}
          anchorReference="anchorPosition"
          anchorPosition={anchorPositions[columnIndex]}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <If condition={column?.field !== 'ranking'}>
            <If condition={fieldOptions.some((field) => field?.value === column?.field)}>
              <MenuItem
                onClick={() => handleMenuItemClick('show Ranking', column?.field, columnIndex)}
              >
                Show Ranking
              </MenuItem>
            </If>
            <MenuItem
              className={
                selectedSortItem.sortType == 'sort up' &&
                selectedSortItem.sortColumnIndex === columnIndex
                  ? 'Mui-selected'
                  : ''
              }
              onClick={() => handleMenuItemClick('Sort Up', column.field, columnIndex)}
            >
              Sort Up
            </MenuItem>
            <MenuItem
              className={
                selectedSortItem.sortType == 'sort down' &&
                selectedSortItem.sortColumnIndex === columnIndex
                  ? 'Mui-selected'
                  : ''
              }
              onClick={() => handleMenuItemClick('Sort Down', column.field, columnIndex)}
            >
              Sort Down
            </MenuItem>
            <MenuItem
              disabled={column?.field == 'total'}
              onClick={() => handleMenuItemClick('Hide Column', column.field, columnIndex)}
            >
              Hide Column
            </MenuItem>
            <MenuItem
              disabled={hiddenColumns.length == 0}
              onClick={() => handleMenuItemClick('Unhide Columns', column.field, columnIndex)}
            >
              Unhide Columns
            </MenuItem>
          </If>
          <If condition={column.field == 'ranking'}>
            <MenuItem
              style={{
                display: 'inline-block',
                padding: '8px 12px',
                cursor: 'pointer',
                width: '100%',
              }}
              onMouseEnter={handleRankingMouseEnter}
              onMouseLeave={handleRankingMouseLeave}
              ref={popoverRef}
            >
              Rank Data By
            </MenuItem>
            <MenuItem
              className={
                selectedSortItem.sortType == 'sort up' &&
                selectedSortItem.sortColumnIndex === columnIndex
                  ? 'Mui-selected'
                  : ''
              }
              onClick={() => handleMenuItemClick('Sort Up', column.field, columnIndex)}
            >
              Sort Up
            </MenuItem>
            <MenuItem
              className={
                selectedSortItem.sortType == 'sort down' &&
                selectedSortItem.sortColumnIndex === columnIndex
                  ? 'Mui-selected'
                  : ''
              }
              onClick={() => handleMenuItemClick('Sort Down', column.field, columnIndex)}
            >
              Sort Down
            </MenuItem>
            <MenuItem
              disabled={column?.field == 'total'}
              onClick={() => handleMenuItemClick('Hide Column', column.field, columnIndex)}
            >
              Hide Column
            </MenuItem>
            <MenuItem
              disabled={hiddenColumns.length == 0}
              onClick={() => handleMenuItemClick('Unhide Columns', column.field, columnIndex)}
            >
              Unhide Columns
            </MenuItem>
          </If>
        </Popover>
      </>
    );
  };

  const renderHeader = () => {
    return (
      <tr>
        {filteredColumnList.map((column, columnIndex) => {
          if (!column.hidden) {
            return (
              <th
                key={column.field}
                style={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 100,
                  backgroundColor: '#003C6F',
                  color: '#fff',
                }}
              >
                {headerComponent(column, columnIndex)}
              </th>
            );
          }
        })}
      </tr>
    );
  };

  const handleCloseFilterName = () => {
    setOpenFilterName(false);
    handleCloseFilterValidation();
    setFilterName('');
  };

  const handleCloseFilterValidation = async () => {
    setOpenFilterValidation(false);
  };

  const addSelClassToSearchButton = (index) => {
    const buttons = document.querySelectorAll(`[id^="button-"]`);
    const clickedButton = document.getElementById('button-' + index);
    const parentDiv = clickedButton.parentElement;
    buttons.forEach((button) => {
      if (button !== clickedButton) {
        const parentDiv = button.parentElement;
        parentDiv.classList.add(classes.TableInnerFilter);
        parentDiv.classList.remove(classes.TableInnerFilterSelect);
      }
    });

    parentDiv.classList.add(classes.TableInnerFilterSelect); // Add filterselected class to the clicked button
    parentDiv.classList.remove(classes.TableInnerFilter);
  };

  const handleSearchButtonClick = async (
    event,
    index,
    _id,
    _values,
    selectedSection,
    { resetForm },
  ) => {
    setHiddenColumns([]);
    const clickedButton = event.target.parentElement;
    const buttonId = `button-${index}`;
    const buttonElement = event.currentTarget;
    const buttonIdFromEvent = buttonElement.getAttribute('id');

    if (selectedSection === 'button') {
      setSelectedSearchIndex(index);
      setSelectedSearchId(_id);
      if (selectedSearchIndex === index) {
        clearSelectedSearch({ resetForm });
      } else {
        if (
          clickedButton.parentElement.tagName !== 'SPAN' &&
          !clickedButton.parentElement.id.includes('buttonArrow')
        ) {
          addSelClassToSearchButton(index);
          setFilterSelectedUpdate(savedSearches.filter((elem) => elem.id === _id));

          if (buttonId === buttonIdFromEvent) {
            await loadSelectedSearch(_id, _values);
          }
        }
      }
    } else if (selectedSection === 'arrow') {
      // Only allow the arrow to open if this search is the currently selected one.
      // (You might also want to visually disable arrows for unselected searches.)
      if (selectedSearchId && _id === selectedSearchId) {
        // Only open the arrow dropdown when the user clicks on the arrow for the currently selected saved search.
        setSearchAnchorEl(buttonElement);
      }
      // Otherwise ignore the arrow click.
    }
  };

  const loadSelectedSearch = async (_id, _values) => {
    const selectedSearch = savedSearches.filter((elem) => elem.id === _id);

    _values['countryid'] = selectedSearch[0].country.length > 0 ? selectedSearch[0].country : [];
    _values['cellid'] = selectedSearch[0].cell.length > 0 ? selectedSearch[0].cell : [];
    _values['yearid'] = Number(selectedSearch[0].year);
    _values['period'] = selectedSearch[0].period;
    if (typeof _values['period'] === 'string') {
      try {
        _values['period'] = JSON.parse(_values['period']);
      } catch {
        _values['period'] = [];
      }
    }

    _values['deptid'] = selectedSearch[0].department.length > 0 ? selectedSearch[0].department : [];
    _values['fieldoptionid'] = selectedSearch[0].metrics || [];

    const yearToLoad = {
      id: selectedSearch[0].year,
      year: yearListForFilter.find((d) => d?.id == selectedSearch[0].year)?.year,
    };
    setSelectedYear(yearToLoad);
    if (selectedSearch[0].country.length > 0) {
      let loadedCountries = [];
      selectedSearch[0].country.map((country) => {
        loadedCountries.push(JSON.parse(country));
      });

      await loadCellsForFilter(loadedCountries);
    }

    await setLoadedFilterOptions(_values, selectedSearch);
    if (allFinancialCompensationData.length > 0) {
      const isNewEntry = await updateArrayB(
        allFinancialCompensationData,
        reportData,
        yearListForFilter.find((d) => d?.id == selectedSearch[0].year)?.year,
      );
    }

    setFilterSubmitted(_values);
    return true;
  };

  // Modify setLoadedFilterOptions to update the flag after setting the state:
  const setLoadedFilterOptions = async (_values) => {
    const fieldToLoad = fieldOptions.filter((field) =>
      _values['fieldoptionid'].some((f) => f === field.value),
    );

    const countryToLoad = _values['countryid'].map((country) => JSON.parse(country));
    const cellsToLoad = _values['cellid'].map((cell) => JSON.parse(cell));
    const deptsToLoad = _values['deptid'].map((dept) => JSON.parse(dept));
    const monthToLoad = _values['period'];

    setSelectedFieldOption(fieldToLoad);
    setSelectedCountryOption(countryToLoad);
    setSelectedCellOption(cellsToLoad);
    setSelectedDepartmentOption(deptsToLoad);
    setSelectedMonthOption(monthToLoad);

    setFilterOptionsUpdated(true);
  };

  useEffect(() => {
    if (filterOptionsUpdated) {
      const runFilter = async () => {
        await filterFpData(filterSubmitted);
        setFilterOptionsUpdated(false);
      };
      runFilter();
    }
  }, [filterOptionsUpdated, filterSubmitted]);

  const handleMenuClose = () => {
    setSearchAnchorEl(null);
  };

  const handleOutsideClick = () => {};
  const handleDeleteSearch = async (searchId, { resetForm }) => {
    const result = await deleteSelectedFilter({ userId: loggedInUserData?.id, searchId: searchId });

    if (result) {
      clearAll();
      loadAllFilters();
      handleMenuClose();
      clearSelectedSearch({ resetForm });
    }
  };

  const openDeleteConfirmationBox = async () => {
    handleSubmenuClose();
    setOpenDeleteConfirmation(true);
    handleClose();
  };

  const handleDeleteSavedSearches = async ({ resetForm }, isDeleteAll) => {
    handleSubmenuClose();
    closeDeleteConfirmation();

    if (isDeleteAll) {
      const result = await deleteAllFilters({ userId: loggedInUserData?.id });
      if (result) {
        loadAllFilters();
        clearSelectedSearch({ resetForm });
      }
    } else {
      handleDeleteSearch(selectedSearchId, { resetForm });
    }
  };

  const closeDeleteConfirmation = async () => {
    setOpenDeleteConfirmation(false);
  };
  const handleRenameButton = (_id) => {
    handleMenuClose();
    setOpenFilterRename(true);
    setFilterSelectedUpdate({});
    if (savedSearches && savedSearches.length > 0) {
      setFilterRename(savedSearches.filter((elem) => elem.id === _id)[0]?.filterName);
      setFilterSelectedUpdate(savedSearches.filter((elem) => elem.id === _id));
    }
  };
  const handleCloseFilterRename = () => {
    setOpenFilterRename(false);
    setFilterSelectedUpdate({});
  };

  const safeNumber = (value) => {
    // If the value is a string and equals "N/A" (ignoring case), return 0
    if (typeof value === 'string' && value.trim().toUpperCase() === 'N/A') {
      return 0;
    }
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };

  const loadFpData = async (year) => {
    let effectiveYear;
    if (year && Object.keys(year).length > 0 && year.id !== undefined && year.year !== undefined) {
      effectiveYear = year;
    } else if (
      selectedYear &&
      Object.keys(selectedYear).length > 0 &&
      selectedYear.id !== undefined &&
      selectedYear.year !== undefined
    ) {
      effectiveYear = selectedYear;
    } else {
      effectiveYear = initialYearState;
    }

    finDataAll = await getFinParamsUsers({
      selectedCellOption,
      selectedCountryOption,
      selectedDepartmentOption,
      selectedMonthOption,
      selectedYear: effectiveYear,
      selectedFieldOption,
    });

    const raw = Array.isArray(finDataAll.usersResult) ? finDataAll.usersResult : [];
    const processedData = raw.map((data) => {
      const bonuses = safeNumber(data?.bonuses);
      const salary = safeNumber(data?.salary);
      const commissions = safeNumber(data?.commissions);
      const benefits = safeNumber(data?.benefits);
      const expenseReport = safeNumber(data?.expenseReport);
      return {
        ...data,
        total: bonuses + salary + commissions + benefits + expenseReport,
      };
    });

    calculateRank('show ranking', 'bonuses', processedData);
    setFilteredFpData(processedData);
    setFilteredFpDataClone(processedData);
    return processedData;
  };

  const loadCountries = async () => {
    const countryLists = await getCountry();
    const countries = countryLists.usersResult || [];
    setCountryList(countries);
  };

  const loadAllCellList = async () => {
    const cellLists = await fetchAllCellList();
    const cells = cellLists.usersResult || [];
    setCopyCellListForFilter(cells);
    setCellListForFilter(cells);
  };

  const loadCellsForFilter = async (countryIdList) => {
    if (countryIdList.length > 0) {
      const CellList = await getCountriesCells(countryIdList);
      setCellListForFilter(CellList.usersResult);
    } else {
      setCellListForFilter(copyCellListForFilter);
    }
  };

  const loadDeptForFilter = async () => {
    const DeptList = await getDepartmentData();
    setDeptListForFilter(DeptList.usersResult || []);
  };

  const loadYearForFilter = async () => {
    const currentYear = new Date().getFullYear();
    const startYear = 2019;
    const numberOfYears = currentYear - startYear + 1;

    const yearsArray = Array.from({ length: numberOfYears }, (_, index) => {
      return {
        id: index + 1,
        year: (startYear + index).toString(),
      };
    });

    setYearListForFilter(yearsArray);
    return yearsArray;
  };

  const isValidJSON = (obj) => {
    try {
      JSON.parse(obj);
      return true;
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    if (filteredFpData && filteredFpData.length > 0) {
      // Get the available fields from the API data (assumes uniform structure)
      const availableFields = Object.keys(filteredFpData[0]);

      // Define the desired order for the columns.
      // Only these fields, in this order, will be displayed.
      const desiredOrder = [
        'ranking',
        'name',
        'country',
        'cell',
        'department',
        'salary',
        'bonuses',
        'commissions',
        'benefits',
        'expenseReport',
        'total',
      ];

      const computedColumns = desiredOrder.map((field) => {
        const title =
          field === 'name'
            ? 'Employee Name'
            : field === 'expenseReport'
            ? 'Expense Report'
            : field.charAt(0).toUpperCase() + field.slice(1);
        if (field === 'total') {
          return {
            key: field, // Unique key for the column
            field,
            title,
            render: (data) => {
              const computedTotal =
                data.total ||
                (Number(data.salary) || 0) +
                  (Number(data.bonuses) || 0) +
                  (Number(data.commissions) || 0) +
                  (Number(data.benefits) || 0) +
                  (Number(data.expenseReport) || 0);
              return formatToCurrency(computedTotal, classes);
            },
            hidden: false,
          };
        }
        return {
          key: field,
          field,
          title,
          render: (data) => data[field],
          hidden: !availableFields.includes(field) || hiddenColumns.includes(field),
        };
      });

      setFilteredColumnList(computedColumns);
    } else {
      setFilteredColumnList([]);
    }
  }, [filteredFpData, hiddenColumns]);

  const filterFpData = async (filter) => {
    setOpenFilter(false);
    const yearList = {
      id: filter?.yearid,
      year: yearListForFilter.find((d) => d?.id == filter?.yearid)?.year,
    };
    setSelectedYear(yearList);
    const loadedFpData = await loadFpData(yearList);
    calculateRank('show ranking', 'bonuses', loadedFpData);
    return true;
  };

  const loadAllFilters = async () => {
    if (loggedInUserData) {
      const filterData = await getAllFilters({ userId: loggedInUserData?.id });
      setSavedSearches(filterData.usersResult || []);
    }
  };

  const clearSelectedSearch = ({ resetForm }) => {
    setSelectedSearchIndex(null);
    setSelectedSearchId(null);
    setFilterEditMode(false);
    removeButtonSelection();
    clearAll();
    resetForm();
  };
  const removeButtonSelection = () => {
    const buttons = document.querySelectorAll(`[id^="button-"]`);
    buttons.forEach((button) => {
      const parentDiv = button.parentElement;
      parentDiv.classList.add(classes.TableInnerFilter);
      parentDiv.classList.remove(classes.TableInnerFilterSelect);
    });
  };

  const cellsInCountryIndicator = (cellData) => {
    const updatedCellsByCountry = {};
    cellData.forEach(({ cellTitle, countryId }) => {
      const country = selectedCountryOption.find(({ id }) => id === countryId);
      if (country) {
        if (!updatedCellsByCountry[country.countryTitle]) {
          updatedCellsByCountry[country.countryTitle] = new Set([cellTitle]);
        } else {
          updatedCellsByCountry[country.countryTitle].add(cellTitle);
        }
      }
    });
    setCellsByCountryIndicator(updatedCellsByCountry);
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        exitFullscreen();
        setIsFocusMode(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  useEffect(() => {
    if (popoverRef.current) {
      const popoverWidth = popoverRef.current.parentElement.offsetWidth;
      const popoverTop = popoverRef.current.parentElement.offsetTop + scrollTop;
      const popoverLeft = popoverRef.current.parentElement.offsetLeft;

      setRankDataByWidth({ width: popoverWidth, top: popoverTop, left: popoverLeft });
    }
  }, [anchorPositions]);

  useEffect(() => {}, [selectedSortItem]);

  useEffect(() => {
    loadCountries();
  }, []);

  useEffect(() => {
    loadDeptForFilter();
  }, []);

  useEffect(() => {
    loadAllCellList();
  }, []);
  useEffect(() => {
    loadAllFilters();
  }, [openFilterRename]);

  useEffect(() => {
    cellsInCountryIndicator(selectedCellOption);
  }, [selectedCountryOption, selectedCellOption, selectedDepartmentOption, selectedFieldOption]);

  useEffect(() => {
    loadYearForFilter();
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !event.target.closest('#countryAutoComplete') &&
        !event.target.closest('#country-popup') &&
        !event.target.closest('#countryAutoCompleteMob')
      ) {
        // Clicked outside of .your-element-class, do something...countryAutoCompleteMob
        setOpenCountry(false);
        setOpenCountryClick(false);
      }
      if (event.target.closest('#countryAutoComplete')) {
        if (openCountry) {
          setOpenCountryClick(true);
        }

        if (openCountryClick && openCountry) {
          setOpenCountryClick(false);
          setOpenCountry(false);
        }
      }
    }

    // Attach the event listener on component mount
    window.addEventListener('click', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [openCountryClick, openCountry]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setScrollTop(scrollTop);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (allFinancialCompensationData?.length > 0) {
      const isNewEntry = updateArrayB(allFinancialCompensationData, reportData, selectedYear);
      if (!isNewEntry) {
        displayedFpData = selectedSortItem.sortField
          ? filteredFpData.slice(startFpIndex, endFpIndex)
          : filteredFpDataClone.slice(startFpIndex, endFpIndex) || [];
      }
    }

    const calculateTotals = () => {
      const totals = filteredFpData.reduce((acc, item) => {
        acc.bonuses = (acc.bonuses || 0) + (parseFloat(item?.bonuses) || 0);
        acc.salary = (acc.salary || 0) + (parseFloat(item?.salary) || 0);
        acc.commissions = (acc.commissions || 0) + (parseFloat(item?.commissions) || 0);
        acc.benefits = (acc.benefits || 0) + (parseFloat(item?.benefits) || 0);
        acc.expenseReport = (acc.expenseReport || 0) + (parseFloat(item?.expenseReport) || 0);
        acc.total = acc.bonuses + acc.salary + acc.commissions + acc.benefits + acc.expenseReport;
        return acc;
      }, {});
      setTotals(totals);
    };

    calculateTotals();
  }, [filteredFpData]);

  //T0-DO: Can be removed,needs to be checked
  const updateArrayB = async (arrayA, arrayB, selectedYear) => {
    let isNewEntry = false;

    arrayA?.forEach((entryA, index) => {
      if (entryA.year === selectedYear) {
        const fullName = `${entryA.firstName} ${entryA.lastName}`;
        const indexB = arrayB.findIndex(
          (entryB) => entryB.employee.toLowerCase() === fullName?.toLowerCase(),
        );
        const { employeeId: empId, countryId } =
          fpData?.find((fpd) => {
            return fpd?.employee?.toLowerCase() === fullName?.toLowerCase();
          }) || {};

        if (index == 0 && indexB !== -1) {
          arrayB[indexB].salary = 0;
          arrayB[indexB].bonuses = 0;
        }

        if (indexB !== -1) {
          // Update existing entry in Array B
          arrayB[indexB].salary = parseFloat(arrayB[indexB].salary) + parseFloat(entryA.salary);
          arrayB[indexB].bonuses = parseFloat(arrayB[indexB].bonuses) + parseFloat(entryA.bonuses);
        } else {
          // Add new entry to Array B
          isNewEntry = true;
          arrayB.push({
            year: entryA.year,
            employee: `${entryA.firstName} ${entryA.lastName}`,
            employeeId: empId,
            countryId: countryId, // Assuming no countryId in Array A
            country: entryA.countryTitle,
            cell: entryA.cellTitle,
            department: entryA.departmentTitle,
            total: entryA.total,
            bonuses: entryA.bonuses,
            salary: entryA.salary,
            ranking: {
              fieldSelected: '',
              rankValue: 0, // Assuming default rankValue
            },
          });
        }
      }
    });

    if (isNewEntry) {
      setFpData((prevFpData) => {
        // Ensure no duplicates in fpData
        const updatedFpData = [...prevFpData, ...arrayB];
        const uniqueFpData = updatedFpData.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.employeeId === value.employeeId),
        );
        return uniqueFpData;
      });
    }
    return isNewEntry;
  };

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  const handleClickOpenFilter = () => {
    setOpenFilter(true);
  };
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setOpenFilterValidation(false);
  };
  const handleSubmenuClose = () => {};
  return (
    <>
      <If condition={isFinAnalysisVisible && fpData}>
        {' '}
        <Grid
          container
          spacing={4}
          className={classes.QuarterlyMeetingObjectives}
          style={{ marginTop: 0 }}
        >
          <Grid item xs={12} className={classes.innercontent}>
            <Grid container style={{ height: '100%' }}>
              <Grid item xs={12}>
                <Grid container>
                  <Formik
                    enableReinitialize={false}
                    initialValues={{
                      countryid: [],
                      cellid: [],
                      yearid: yearListForFilter[yearListForFilter.length - 1]?.id,
                      period: [],
                    }}
                  >
                    {({ isSubmitting, setFieldValue, setFieldTouched, values, resetForm }) => {
                      return (
                        <>
                          <Box pb={2}>
                            <Grid container direction="row">
                              <Grid item xs={12} className={classes.FilterButtonMobile}>
                                <Box>
                                  <Button
                                    startIcon={<FilterListIcon />}
                                    color="primary"
                                    onClick={handleClickOpenFilter}
                                  >
                                    Filters
                                  </Button>
                                  <If condition={openFilter}>
                                    <Dialog
                                      fullScreen
                                      open={openFilter}
                                      onClose={handleCloseFilter}
                                      TransitionComponent={Transition}
                                    >
                                      <DialogTitle id="simple-dialog-title">
                                        <Box display="flex" justifyContent="space-between">
                                          <Box
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                              resetForm();
                                              clearAll();
                                              removeButtonSelection();
                                            }}
                                          >
                                            Clear All
                                          </Box>
                                          <Box>
                                            <b>Filters</b>
                                          </Box>
                                          <Box
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleCloseFilter}
                                          >
                                            Cancel
                                          </Box>
                                        </Box>
                                      </DialogTitle>
                                      <DialogContent>
                                        <Grid container spacing={2}>
                                          <Grid
                                            item
                                            xs={12}
                                            className={classes.FilterDropdownWidthSelectMob}
                                          >
                                            <Autocomplete
                                              multiple
                                              id="fieldsOptions-mob"
                                              disableCloseOnSelect
                                              options={[SelectAllFields, ...fieldOptions]}
                                              getOptionLabel={(option) => {
                                                return option?.label;
                                              }}
                                              onChange={(newValue) => {
                                                newValue.length === 0 &&
                                                  setSelectedFieldOption(newValue);
                                              }}
                                              renderTags={() => {}}
                                              renderOption={(option) => {
                                                return (
                                                  <React.Fragment>
                                                    {option === SelectAllFields ? (
                                                      <FormControlLabel
                                                        control={
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={
                                                              selectedFieldOption.length ===
                                                              fieldOptions.length
                                                            }
                                                          />
                                                        }
                                                        label={option.label}
                                                        onChange={(event) => {
                                                          if (event.target.checked) {
                                                            setSelectedFieldOption(fieldOptions);
                                                            const fieldOptioIdValues =
                                                              fieldOptions.map((field) => {
                                                                return field.value;
                                                              });
                                                            setFieldValue(
                                                              'fieldoptionid',
                                                              fieldOptioIdValues || [],
                                                            );
                                                          } else {
                                                            setFieldValue('fieldoptionid', []);
                                                            setSelectedFieldOption([]);
                                                          }
                                                        }}
                                                      />
                                                    ) : (
                                                      <FormControlLabel
                                                        control={
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={selectedFieldOption.some(
                                                              (selectedOption) =>
                                                                selectedOption.value ===
                                                                option.value,
                                                            )}
                                                            onChange={() => {
                                                              setIsApplyClicked(false);
                                                              const isSelected =
                                                                selectedFieldOption.some(
                                                                  (selectedOption) =>
                                                                    selectedOption.value ===
                                                                    option.value,
                                                                );

                                                              let newSelectedOptions = [];

                                                              if (isSelected) {
                                                                newSelectedOptions =
                                                                  selectedFieldOption.filter(
                                                                    (selectedOption) =>
                                                                      selectedOption.value !==
                                                                      option.value,
                                                                  );
                                                              } else {
                                                                newSelectedOptions = [
                                                                  ...selectedFieldOption,
                                                                  option,
                                                                ];
                                                              }

                                                              setSelectedFieldOption(
                                                                newSelectedOptions,
                                                              );

                                                              const fieldOptioIdValues =
                                                                newSelectedOptions.map((field) => {
                                                                  return field.value;
                                                                });
                                                              setFieldValue(
                                                                'fieldoptionid',
                                                                fieldOptioIdValues || [],
                                                              );
                                                            }}
                                                          />
                                                        }
                                                        label={option.label}
                                                      />
                                                    )}
                                                  </React.Fragment>
                                                );
                                              }}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  name="fieldoptionid"
                                                  variant="outlined"
                                                  label={
                                                    selectedFieldOption.length > 1 &&
                                                    selectedFieldOption.length <=
                                                      fieldOptions.length
                                                      ? 'Multiple Metrics'
                                                      : selectedFieldOption.length == 1
                                                      ? selectedFieldOption[0].label
                                                      : 'Select Metric'
                                                  }
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            className={classes.FilterDropdownWidthSelectMob}
                                          >
                                            <div id="countryAutoCompleteMob">
                                              <Autocomplete
                                                multiple
                                                id="country-mob"
                                                disableCloseOnSelect
                                                options={[SelectAllCountries, ...countryList]}
                                                getOptionLabel={(option) => {
                                                  return option?.countryTitle;
                                                }}
                                                onChange={(event, newValue) => {
                                                  if (newValue.length == 0) {
                                                    setCellListForFilter(copyCellListForFilter);
                                                  }

                                                  newValue.length === 0 &&
                                                    setSelectedCountryOption(newValue);
                                                }}
                                                renderTags={() => {}}
                                                renderOption={(option) => (
                                                  <React.Fragment>
                                                    {option === SelectAllCountries ? (
                                                      <FormControlLabel
                                                        control={
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={
                                                              selectedCountryOption.length ===
                                                              countryList.length
                                                            }
                                                          />
                                                        }
                                                        label={option.countryTitle}
                                                        onChange={(event) => {
                                                          if (event.target.checked) {
                                                            setSelectedCountryOption(countryList);
                                                            setFieldValue(
                                                              'countryid',
                                                              countryList || [],
                                                            );
                                                            loadCellsForFilter(
                                                              selectedCountryOption || [],
                                                            );
                                                          } else {
                                                            setFieldValue('countryid', []);
                                                            setSelectedCountryOption([]);
                                                            loadCellsForFilter(
                                                              selectedCountryOption || [],
                                                            );
                                                          }
                                                        }}
                                                      />
                                                    ) : (
                                                      <FormControlLabel
                                                        control={
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={selectedCountryOption.some(
                                                              (selectedOption) =>
                                                                selectedOption.countryTitle ===
                                                                option.countryTitle,
                                                            )}
                                                            onChange={() => {
                                                              setIsApplyClicked(false);
                                                              const isSelected =
                                                                selectedCountryOption.some(
                                                                  (selectedOption) =>
                                                                    selectedOption.countryTitle ===
                                                                    option.countryTitle,
                                                                );

                                                              let newSelectedOptions = [];

                                                              if (isSelected) {
                                                                newSelectedOptions =
                                                                  selectedCountryOption.filter(
                                                                    (selectedOption) =>
                                                                      selectedOption.countryTitle !==
                                                                      option.countryTitle,
                                                                  );
                                                              } else {
                                                                newSelectedOptions = [
                                                                  ...selectedCountryOption,
                                                                  option,
                                                                ];
                                                              }

                                                              setSelectedCountryOption(
                                                                newSelectedOptions,
                                                              );
                                                              setFieldValue(
                                                                'countryid',
                                                                newSelectedOptions || [],
                                                              );
                                                              loadCellsForFilter(
                                                                newSelectedOptions || [],
                                                              );
                                                            }}
                                                          />
                                                        }
                                                        label={option.countryTitle}
                                                      />
                                                    )}
                                                  </React.Fragment>
                                                )}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    name="countryid"
                                                    variant="outlined"
                                                    label={
                                                      selectedCountryOption.length > 1 &&
                                                      selectedCountryOption.length <=
                                                        countryList.length
                                                        ? 'Multiple Countries'
                                                        : selectedCountryOption.length == 1
                                                        ? selectedCountryOption[0].countryTitle
                                                        : 'Select Country'
                                                    }
                                                  />
                                                )}
                                                popupIcon={<ExpandMoreIcon />}
                                              />
                                            </div>
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            className={classes.FilterDropdownWidthSelectMob}
                                          >
                                            <Autocomplete
                                              multiple
                                              id="cells-mob"
                                              disableCloseOnSelect
                                              options={[SelectAllCells, ...cellListForFilter]}
                                              getOptionLabel={(option) => {
                                                return option?.cellTitle;
                                              }}
                                              onChange={(event, newValue) => {
                                                newValue.length === 0 &&
                                                  setSelectedCellOption(newValue);
                                              }}
                                              renderTags={() => {}}
                                              renderOption={(option) => (
                                                <React.Fragment>
                                                  {option === SelectAllCells ? (
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          icon={icon}
                                                          checkedIcon={checkedIcon}
                                                          style={{ marginRight: 8 }}
                                                          checked={
                                                            selectedCellOption.length ===
                                                            cellListForFilter.length
                                                          }
                                                        />
                                                      }
                                                      label={option.cellTitle}
                                                      onChange={(event) => {
                                                        if (event.target.checked) {
                                                          setSelectedCellOption(cellListForFilter);
                                                          setFieldValue(
                                                            'cellid',
                                                            cellListForFilter || [],
                                                          );
                                                        } else {
                                                          setFieldValue('cellid', []);
                                                          setSelectedCellOption([]);
                                                        }
                                                      }}
                                                    />
                                                  ) : (
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          icon={icon}
                                                          checkedIcon={checkedIcon}
                                                          style={{ marginRight: 8 }}
                                                          checked={selectedCellOption.some(
                                                            (selectedOption) =>
                                                              selectedOption.cellTitle ===
                                                              option.cellTitle,
                                                          )}
                                                          onChange={() => {
                                                            setIsApplyClicked(false);
                                                            const isSelected =
                                                              selectedCellOption.some(
                                                                (selectedOption) =>
                                                                  selectedOption.cellTitle ===
                                                                  option.cellTitle,
                                                              );

                                                            let newSelectedOptions = [];

                                                            if (isSelected) {
                                                              newSelectedOptions =
                                                                selectedCellOption.filter(
                                                                  (selectedOption) =>
                                                                    selectedOption.cellTitle !==
                                                                    option.cellTitle,
                                                                );
                                                            } else {
                                                              newSelectedOptions = [
                                                                ...selectedCellOption,
                                                                option,
                                                              ];
                                                            }

                                                            setSelectedCellOption(
                                                              newSelectedOptions,
                                                            );
                                                            setFieldValue(
                                                              'cellid',
                                                              newSelectedOptions || [],
                                                            );
                                                          }}
                                                        />
                                                      }
                                                      label={option.cellTitle}
                                                    />
                                                  )}
                                                </React.Fragment>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  name="cellid"
                                                  variant="outlined"
                                                  label={
                                                    selectedCellOption.length > 1 &&
                                                    selectedCellOption.length <=
                                                      cellListForFilter.length
                                                      ? 'Multiple Cells'
                                                      : selectedCellOption.length == 1
                                                      ? selectedCellOption[0].cellTitle
                                                      : 'Select Cell'
                                                  }
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            className={classes.FilterDropdownWidthSelectMob}
                                          >
                                            <Autocomplete
                                              multiple
                                              id="departments"
                                              disableCloseOnSelect
                                              options={[SelectAllDepartments, ...deptListForFilter]}
                                              getOptionLabel={(option) => {
                                                return option?.department;
                                              }}
                                              onChange={(event, newValue) => {
                                                newValue.length === 0 &&
                                                  setSelectedDepartmentOption(newValue);
                                              }}
                                              renderTags={() => {}}
                                              renderOption={(option) => (
                                                <React.Fragment>
                                                  {option === SelectAllDepartments ? (
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          icon={icon}
                                                          checkedIcon={checkedIcon}
                                                          style={{ marginRight: 8 }}
                                                          checked={
                                                            selectedDepartmentOption.length ===
                                                            deptListForFilter.length
                                                          }
                                                        />
                                                      }
                                                      label={option.department}
                                                      onChange={(event) => {
                                                        if (event.target.checked) {
                                                          setSelectedDepartmentOption(
                                                            deptListForFilter,
                                                          );
                                                          setFieldValue(
                                                            'deptid',
                                                            deptListForFilter || [],
                                                          );
                                                        } else {
                                                          setFieldValue('deptid', []);
                                                          setSelectedDepartmentOption([]);
                                                        }
                                                      }}
                                                    />
                                                  ) : (
                                                    <FormControlLabel
                                                      control={
                                                        <Checkbox
                                                          icon={icon}
                                                          checkedIcon={checkedIcon}
                                                          style={{ marginRight: 8 }}
                                                          checked={selectedDepartmentOption.some(
                                                            (selectedOption) =>
                                                              selectedOption.department ===
                                                              option.department,
                                                          )}
                                                          onChange={() => {
                                                            setIsApplyClicked(false);
                                                            const isSelected =
                                                              selectedDepartmentOption.some(
                                                                (selectedOption) =>
                                                                  selectedOption.department ===
                                                                  option.department,
                                                              );

                                                            let newSelectedOptions = [];

                                                            if (isSelected) {
                                                              newSelectedOptions =
                                                                selectedDepartmentOption.filter(
                                                                  (selectedOption) =>
                                                                    selectedOption.department !==
                                                                    option.department,
                                                                );
                                                            } else {
                                                              newSelectedOptions = [
                                                                ...selectedDepartmentOption,
                                                                option,
                                                              ];
                                                            }

                                                            setSelectedDepartmentOption(
                                                              newSelectedOptions,
                                                            );
                                                            setFieldValue(
                                                              'deptid',
                                                              newSelectedOptions || [],
                                                            );
                                                          }}
                                                        />
                                                      }
                                                      label={option.department}
                                                    />
                                                  )}
                                                </React.Fragment>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  name="deptid"
                                                  variant="outlined"
                                                  label={
                                                    selectedDepartmentOption.length > 1 &&
                                                    selectedDepartmentOption.length <=
                                                      deptListForFilter.length
                                                      ? 'Multiple Departments'
                                                      : selectedDepartmentOption.length == 1
                                                      ? selectedDepartmentOption[0].department
                                                      : 'Select Department'
                                                  }
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>

                                          <Grid item xs={12}>
                                            <Autocomplete
                                              disablePortal={true}
                                              options={yearListForFilter}
                                              getOptionLabel={(option) => option?.year}
                                              getOptionSelected={(option, value) =>
                                                option?.id === value?.id
                                              }
                                              value={
                                                yearListForFilter.length > 0 && !values?.yearid
                                                  ? yearListForFilter[yearListForFilter.length - 1]
                                                  : values?.yearid
                                                  ? yearListForFilter.find(
                                                      (d) => d?.id === values?.yearid,
                                                    )
                                                  : null
                                              }
                                              onChange={(e, value) => {
                                                setFieldValue('yearid', value?.id || '');
                                                setFieldTouched('yearid');
                                              }}
                                              renderOption={(option, { selected }) => (
                                                <RadioGroup>
                                                  <FormControlLabel
                                                    value={option.id}
                                                    control={<Radio checked={selected} />}
                                                    label={option.year}
                                                  />
                                                </RadioGroup>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  name="yearid"
                                                  variant="outlined"
                                                  label="Year"
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>
                                        </Grid>
                                      </DialogContent>
                                      <DialogActions>
                                        <Button
                                          type="submit"
                                          variant="contained"
                                          color="primary"
                                          onClick={async () => {
                                            setIsApplyClicked(true);

                                            if (values?.fieldoptionid) {
                                              fillReportState(
                                                loadedFpData,
                                                yearListForFilter.find(
                                                  (d) => d.id === selectedYear.id,
                                                )?.year,
                                              );
                                              if (values['yearid'] === undefined) {
                                                values['yearid'] =
                                                  yearListForFilter.length > 0
                                                    ? yearListForFilter[
                                                        yearListForFilter.length - 1
                                                      ]?.id
                                                    : '';
                                                const yearObj = {
                                                  id: values['yearid'],
                                                  year: yearListForFilter.find(
                                                    (d) => d?.id == values['yearid'],
                                                  )?.year,
                                                };

                                                setSelectedYear(yearObj);
                                              }

                                              setFilterSubmitted(values);
                                              setLoaded(filterFpData(values));
                                            }
                                          }}
                                          fullWidth
                                        >
                                          Apply
                                        </Button>
                                      </DialogActions>
                                    </Dialog>
                                  </If>
                                </Box>
                              </Grid>
                              <Grid item xs={12} className={classes.FilterDesktop}>
                                <Grid container spacing={1} className={classes.AutoCompleteDisable}>
                                  <Grid item className={classes.EAFilterDropdownWidth}>
                                    <Autocomplete
                                      multiple
                                      id="fieldsOptions"
                                      disableCloseOnSelect
                                      options={[SelectAllFields, ...fieldOptions]}
                                      getOptionLabel={(option) => {
                                        return option?.label;
                                      }}
                                      onChange={(newValue) => {
                                        setIsApplyClicked(false);
                                        newValue.length === 0 && setSelectedFieldOption(newValue);
                                      }}
                                      renderTags={() => {}}
                                      renderOption={(option) => {
                                        return (
                                          <React.Fragment>
                                            {option === SelectAllFields ? (
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={
                                                      selectedFieldOption.length ===
                                                      fieldOptions.length
                                                    }
                                                  />
                                                }
                                                label={option.label}
                                                onChange={(event) => {
                                                  if (event.target.checked) {
                                                    setSelectedFieldOption(fieldOptions);
                                                    const fieldOptioIdValues = fieldOptions.map(
                                                      (field) => {
                                                        return field.value;
                                                      },
                                                    );
                                                    setFieldValue(
                                                      'fieldoptionid',
                                                      fieldOptioIdValues || [],
                                                    );
                                                  } else {
                                                    setFieldValue('fieldoptionid', []);
                                                    setSelectedFieldOption([]);
                                                  }
                                                }}
                                              />
                                            ) : (
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selectedFieldOption.some(
                                                      (selectedOption) =>
                                                        selectedOption.value === option.value,
                                                    )}
                                                    onChange={() => {
                                                      setIsApplyClicked(false);
                                                      const isSelected = selectedFieldOption.some(
                                                        (selectedOption) =>
                                                          selectedOption.value === option.value,
                                                      );

                                                      let newSelectedOptions = [];

                                                      if (isSelected) {
                                                        newSelectedOptions =
                                                          selectedFieldOption.filter(
                                                            (selectedOption) =>
                                                              selectedOption.value !== option.value,
                                                          );
                                                      } else {
                                                        newSelectedOptions = [
                                                          ...selectedFieldOption,
                                                          option,
                                                        ];
                                                      }

                                                      setSelectedFieldOption(newSelectedOptions);

                                                      const fieldOptioIdValues =
                                                        newSelectedOptions.map((field) => {
                                                          return field.value;
                                                        });
                                                      setFieldValue(
                                                        'fieldoptionid',
                                                        fieldOptioIdValues || [],
                                                      );
                                                    }}
                                                  />
                                                }
                                                label={option.label}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                }}
                                              />
                                            )}
                                          </React.Fragment>
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="fieldoptionid"
                                          variant="outlined"
                                          label={
                                            selectedFieldOption.length > 1 &&
                                            selectedFieldOption.length <= fieldOptions.length
                                              ? 'Multiple Metrics'
                                              : selectedFieldOption.length == 1
                                              ? selectedFieldOption[0].label
                                              : 'Select Metric'
                                          }
                                        />
                                      )}
                                      popupIcon={<ExpandMoreIcon />}
                                    />
                                  </Grid>
                                  <Grid item className={classes.EAFilterDropdownWidth}>
                                    <div id="countryAutoComplete">
                                      <Autocomplete
                                        multiple
                                        id="country"
                                        open={openCountry}
                                        // onOpen={() => setOpenCountry(true)}
                                        onOpen={() => handleToggleOpen('open')}
                                        //onClose={() => handleToggleOpen('close')}
                                        disableCloseOnSelect
                                        options={[SelectAllCountries, ...countryList]}
                                        getOptionLabel={(option) => {
                                          return option?.countryTitle;
                                        }}
                                        onChange={(event, newValue) => {
                                          if (newValue.length == 0) {
                                            setCellListForFilter(copyCellListForFilter);
                                          }
                                          // setFilterEditMode(true);
                                          handleToggleOpen('changeEvent');
                                          // setSelectedCountryOption(newValue);
                                          newValue.length === 0 &&
                                            setSelectedCountryOption(newValue);
                                        }}
                                        renderTags={() => {}}
                                        renderOption={(option) => (
                                          <React.Fragment>
                                            {option === SelectAllCountries ? (
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={
                                                      selectedCountryOption.length ===
                                                      countryList.length
                                                    }
                                                  />
                                                }
                                                label={option.countryTitle}
                                                onChange={(event) => {
                                                  if (event.target.checked) {
                                                    setSelectedCountryOption(countryList);
                                                    setFieldValue('countryid', countryList || []);
                                                    loadCellsForFilter(countryList || []);
                                                  } else {
                                                    setFieldValue('countryid', []);
                                                    setSelectedCountryOption([]);
                                                    loadCellsForFilter(selectedCountryOption || []);
                                                  }
                                                }}
                                              />
                                            ) : (
                                              <FormControlLabel
                                                control={
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selectedCountryOption.some(
                                                      (selectedOption) =>
                                                        selectedOption.countryTitle ===
                                                        option.countryTitle,
                                                    )}
                                                    onChange={() => {
                                                      setIsApplyClicked(false);
                                                      const isSelected = selectedCountryOption.some(
                                                        (selectedOption) =>
                                                          selectedOption.countryTitle ===
                                                          option.countryTitle,
                                                      );

                                                      let newSelectedOptions = [];

                                                      if (isSelected) {
                                                        newSelectedOptions =
                                                          selectedCountryOption.filter(
                                                            (selectedOption) =>
                                                              selectedOption.countryTitle !==
                                                              option.countryTitle,
                                                          );
                                                      } else {
                                                        newSelectedOptions = [
                                                          ...selectedCountryOption,
                                                          option,
                                                        ];
                                                      }

                                                      setSelectedCountryOption(newSelectedOptions);
                                                      setFieldValue(
                                                        'countryid',
                                                        newSelectedOptions || [],
                                                      );
                                                      loadCellsForFilter(newSelectedOptions || []);
                                                      setOpenCountry(true);
                                                    }}
                                                  />
                                                }
                                                label={
                                                  <Typography onClick={(e) => e.stopPropagation()}>
                                                    {option.countryTitle}
                                                  </Typography>
                                                }
                                              />
                                            )}
                                          </React.Fragment>
                                        )}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            name="countryid"
                                            variant="outlined"
                                            label={
                                              selectedCountryOption.length > 1 &&
                                              selectedCountryOption.length <= countryList.length
                                                ? 'Multiple Countries'
                                                : selectedCountryOption.length == 1
                                                ? selectedCountryOption[0].countryTitle
                                                : 'Select Country'
                                            }
                                          />
                                        )}
                                        popupIcon={<ExpandMoreIcon />}
                                      />
                                    </div>
                                  </Grid>

                                  <Grid item className={classes.EAFilterDropdownWidth}>
                                    <Autocomplete
                                      multiple
                                      id="cells"
                                      disableCloseOnSelect
                                      options={[SelectAllCells, ...cellListForFilter]}
                                      getOptionLabel={(option) => {
                                        return option?.cellTitle;
                                      }}
                                      onChange={(event, newValue) => {
                                        newValue.length === 0 && setSelectedCellOption(newValue);
                                      }}
                                      renderTags={() => {}}
                                      renderOption={(option) => (
                                        <React.Fragment>
                                          {option === SelectAllCells ? (
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={
                                                    selectedCellOption.length ===
                                                    cellListForFilter.length
                                                  }
                                                />
                                              }
                                              label={option.cellTitle}
                                              onChange={(event) => {
                                                if (event.target.checked) {
                                                  setSelectedCellOption(cellListForFilter);
                                                  setFieldValue('cellid', cellListForFilter || []);
                                                } else {
                                                  setFieldValue('cellid', []);
                                                  setSelectedCellOption([]);
                                                }
                                              }}
                                            />
                                          ) : (
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={selectedCellOption.some(
                                                    (selectedOption) =>
                                                      selectedOption.cellTitle === option.cellTitle,
                                                  )}
                                                  onChange={() => {
                                                    setIsApplyClicked(false);
                                                    const isSelected = selectedCellOption.some(
                                                      (selectedOption) =>
                                                        selectedOption.cellTitle ===
                                                        option.cellTitle,
                                                    );

                                                    let newSelectedOptions = [];

                                                    if (isSelected) {
                                                      newSelectedOptions =
                                                        selectedCellOption.filter(
                                                          (selectedOption) =>
                                                            selectedOption.cellTitle !==
                                                            option.cellTitle,
                                                        );
                                                    } else {
                                                      newSelectedOptions = [
                                                        ...selectedCellOption,
                                                        option,
                                                      ];
                                                    }

                                                    setSelectedCellOption(newSelectedOptions);
                                                    setFieldValue(
                                                      'cellid',
                                                      newSelectedOptions || [],
                                                    );
                                                  }}
                                                />
                                              }
                                              label={option.cellTitle}
                                            />
                                          )}
                                        </React.Fragment>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="cellid"
                                          variant="outlined"
                                          label={
                                            selectedCellOption.length > 1 &&
                                            selectedCellOption.length <= cellListForFilter.length
                                              ? 'Multiple Cells'
                                              : selectedCellOption.length == 1
                                              ? selectedCellOption[0].cellTitle
                                              : 'Select Cell'
                                          }
                                        />
                                      )}
                                      popupIcon={<ExpandMoreIcon />}
                                    />
                                  </Grid>

                                  <Grid item className={classes.EAFilterDropdownWidth}>
                                    <Autocomplete
                                      multiple
                                      id="departments"
                                      disableCloseOnSelect
                                      options={[SelectAllDepartments, ...deptListForFilter]}
                                      getOptionLabel={(option) => {
                                        return option?.department;
                                      }}
                                      onChange={(event, newValue) => {
                                        newValue.length === 0 &&
                                          setSelectedDepartmentOption(newValue);
                                      }}
                                      renderTags={() => {}}
                                      renderOption={(option) => (
                                        <React.Fragment>
                                          {option === SelectAllDepartments ? (
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={
                                                    selectedDepartmentOption.length ===
                                                    deptListForFilter.length
                                                  }
                                                />
                                              }
                                              label={option.department}
                                              onChange={(event) => {
                                                if (event.target.checked) {
                                                  setSelectedDepartmentOption(deptListForFilter);
                                                  setFieldValue('deptid', deptListForFilter || []);
                                                } else {
                                                  setFieldValue('deptid', []);
                                                  setSelectedDepartmentOption([]);
                                                }
                                              }}
                                            />
                                          ) : (
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={selectedDepartmentOption.some(
                                                    (selectedOption) =>
                                                      selectedOption.department ===
                                                      option.department,
                                                  )}
                                                  onChange={() => {
                                                    setIsApplyClicked(false);
                                                    const isSelected =
                                                      selectedDepartmentOption.some(
                                                        (selectedOption) =>
                                                          selectedOption.department ===
                                                          option.department,
                                                      );

                                                    let newSelectedOptions = [];

                                                    if (isSelected) {
                                                      newSelectedOptions =
                                                        selectedDepartmentOption.filter(
                                                          (selectedOption) =>
                                                            selectedOption.department !==
                                                            option.department,
                                                        );
                                                    } else {
                                                      newSelectedOptions = [
                                                        ...selectedDepartmentOption,
                                                        option,
                                                      ];
                                                    }

                                                    setSelectedDepartmentOption(newSelectedOptions);
                                                    setFieldValue(
                                                      'deptid',
                                                      newSelectedOptions || [],
                                                    );
                                                  }}
                                                />
                                              }
                                              label={option.department}
                                            />
                                          )}
                                        </React.Fragment>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="deptid"
                                          variant="outlined"
                                          label={
                                            selectedDepartmentOption.length > 1 &&
                                            selectedDepartmentOption.length <=
                                              deptListForFilter.length
                                              ? 'Multiple Departments'
                                              : selectedDepartmentOption.length == 1
                                              ? selectedDepartmentOption[0].department
                                              : 'Select Department'
                                          }
                                        />
                                      )}
                                      popupIcon={<ExpandMoreIcon />}
                                    />
                                  </Grid>
                                  <Grid item className={classes.EAFilterDropdownWidth}>
                                    <Autocomplete
                                      multiple
                                      id="months"
                                      disableCloseOnSelect
                                      options={[...periodOptions]}
                                      getOptionLabel={(option) => {
                                        return option?.label;
                                      }}
                                      onChange={(event, newValue) => {
                                        setSelectedMonthOption(newValue);
                                        setFieldValue('period', newValue);
                                      }}
                                      renderTags={() => {}}
                                      renderOption={(option) => (
                                        <React.Fragment>
                                          <FormControlLabel
                                            control={
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selectedMonthOption.some(
                                                  (selectedOption) =>
                                                    selectedOption.label === option.label,
                                                )}
                                                onChange={() => {
                                                  setIsApplyClicked(false);
                                                  const isSelected = selectedMonthOption.some(
                                                    (selectedOption) =>
                                                      selectedOption.label === option.label,
                                                  );

                                                  let newSelectedOptions = [];

                                                  if (isSelected) {
                                                    newSelectedOptions = selectedMonthOption.filter(
                                                      (selectedOption) =>
                                                        selectedOption.label !== option.label,
                                                    );
                                                  } else {
                                                    newSelectedOptions = [
                                                      ...selectedMonthOption,
                                                      option,
                                                    ];
                                                  }

                                                  setSelectedMonthOption(newSelectedOptions);
                                                  setFieldValue('period', newSelectedOptions || []);
                                                }}
                                              />
                                            }
                                            label={option.label}
                                          />
                                        </React.Fragment>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="period"
                                          variant="outlined"
                                          label={
                                            selectedMonthOption.length > 1 &&
                                            selectedMonthOption.length <= periodOptions.length
                                              ? 'Multiple Duration'
                                              : selectedMonthOption.length == 1
                                              ? selectedMonthOption[0].label
                                              : 'Select Duration'
                                          }
                                        />
                                      )}
                                      popupIcon={<ExpandMoreIcon />}
                                    />
                                  </Grid>
                                  <Grid item className={classes.EAFilterDropdownWidth}>
                                    <Autocomplete
                                      options={yearListForFilter}
                                      getOptionLabel={(option) => option?.year}
                                      getOptionSelected={(option, value) =>
                                        option?.id === value?.id
                                      }
                                      value={
                                        yearListForFilter.length > 0 && !values?.yearid
                                          ? yearListForFilter[yearListForFilter.length - 1]
                                          : values?.yearid
                                          ? yearListForFilter.find((d) => d?.id === values?.yearid)
                                          : null
                                      }
                                      defaultYear={yearListForFilter[yearListForFilter.length - 1]}
                                      onChange={(e, value) => {
                                        setFieldValue('yearid', value?.id || '');
                                        setFieldTouched('yearid');
                                        setSelectedYear(value);
                                      }}
                                      renderOption={(option, { selected }) => (
                                        <RadioGroup>
                                          <FormControlLabel
                                            value={option.id}
                                            control={<Radio checked={selected} />}
                                            label={option.year}
                                          />
                                        </RadioGroup>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          name="yearid"
                                          variant="outlined"
                                          label="Year"
                                        />
                                      )}
                                      popupIcon={<ExpandMoreIcon />}
                                    />
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      type="submit"
                                      className={classes.button}
                                      variant="outlined"
                                      onClick={async () => {
                                        setLoaded(false);
                                        setIsApplyClicked(true);
                                        setLoaded(false);
                                        !filterEditMode && removeButtonSelection();

                                        if (values?.fieldoptionid) {
                                          const updateStateAndArray = async () => {
                                            if (values['yearid'] === undefined) {
                                              values['yearid'] =
                                                yearListForFilter.length > 0
                                                  ? yearListForFilter[yearListForFilter.length - 1]
                                                      ?.id
                                                  : '';
                                              setSelectedYear(values['yearid']);
                                            }
                                          };

                                          // Call the async function
                                          updateStateAndArray();
                                          setFilterSubmitted(values);
                                          setLoaded(filterFpData(values));
                                        }
                                      }}
                                    >
                                      Apply
                                    </Button>
                                    {isSubmitting && (
                                      <CircularProgress
                                        size={24}
                                        className={classes.buttonProgress}
                                      />
                                    )}
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      variant="text"
                                      className={classes.clearbtn}
                                      onClick={() => {
                                        clearSelectedSearch({ resetForm });
                                      }}
                                    >
                                      Clear
                                    </Button>
                                  </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                  <Dialog
                                    open={openFilterName}
                                    onClose={handleCloseFilterName}
                                    className={classes.dialogOuterMedium}
                                    fullScreen={fullScreen}
                                    aria-labelledby="responsive-dialog-title"
                                  >
                                    <DialogTitle
                                      className={classes.dialogTitle}
                                      id="responsive-dialog-title"
                                    >
                                      <Typography variant="h2" noWrap component="span">
                                        {`Save search as:`}
                                      </Typography>
                                      <IconButton
                                        aria-label="close"
                                        onClick={handleCloseFilterName}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </DialogTitle>
                                    <DialogContent>
                                      <TextField
                                        autoFocus
                                        margin="dense"
                                        label="Type here..."
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={filterName}
                                        onChange={(e) => {
                                          setFilterName(e.target.value);
                                          setFilterNameValid(true);
                                        }}
                                        error={!isFilterNameValid}
                                        helperText={!isFilterNameValid && 'Required field missing'}
                                      />
                                    </DialogContent>

                                    <DialogActions>
                                      <Button
                                        onClick={async () => {
                                          if (filterEditMode) {
                                            setFilterNameValid(false);
                                            setFilterSubmitted(values);
                                            if (
                                              values['yearid'] &&
                                              values['fieldoptionid'] &&
                                              selectedSearchId
                                            ) {
                                              const filterObj = {
                                                id: selectedSearchId,
                                                metrics: values['fieldoptionid'] || [],
                                                country: values['countryid'] || [],
                                                cell: values['cellid'] || [],
                                                department: values['deptid'] || [],
                                                year: values['yearid'] || '',
                                                period: values['period'] || [],
                                              };
                                              setSelectedYear(values['yearid']);
                                              const result = await updateSavedFilter(filterObj);
                                              if (result) {
                                                handleCloseFilterName();
                                              }
                                            }
                                          } else {
                                            if (filterName.trim() === '') {
                                              setFilterNameValid(false);
                                            } else {
                                              setAnchorEl(null);
                                              const filterObj = {
                                                userId: loggedInUserData?.id || null,
                                                metrics: values['fieldoptionid'] || [],
                                                filterName: filterName,
                                                country: values['countryid'] || [],
                                                cell: values['cellid'] || [],
                                                department: values['deptid'] || [],
                                                year: values['yearid'] || '',
                                                period: values['period'] || [],
                                              };
                                              setSelectedYear(values['yearid']);
                                              const result = await saveFilter(filterObj);

                                              if (result) {
                                                loadAllFilters();

                                                setSelectedSearchIndex(null);
                                                setSelectedSearchId(null);
                                              }
                                              handleCloseFilterName();
                                            }
                                          }
                                        }}
                                        color="primary"
                                        variant="contained"
                                        autoFocus
                                      >
                                        Save
                                      </Button>
                                      <Button
                                        onClick={handleCloseFilterName}
                                        className={classes.secondaryBtnUI}
                                        variant="outlined"
                                        color="secondary"
                                      >
                                        Cancel
                                      </Button>
                                    </DialogActions>
                                  </Dialog>
                                  <Dialog
                                    open={openFilterRename}
                                    onClose={handleCloseFilterRename}
                                    className={classes.dialogOuterMedium}
                                    fullScreen={fullScreen}
                                    aria-labelledby="responsive-dialog-title"
                                  >
                                    <DialogTitle
                                      className={classes.dialogTitle}
                                      id="responsive-dialog-title"
                                    >
                                      <Typography variant="h2" noWrap component="span">
                                        {`Rename your search name as:`}
                                      </Typography>
                                      <IconButton
                                        aria-label="close"
                                        onClick={handleCloseFilterRename}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </DialogTitle>
                                    <DialogContent>
                                      {' '}
                                      <TextField
                                        autoFocus
                                        margin="dense"
                                        label="Edit Your Search Name"
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        value={filterRename || ''}
                                        onChange={(e) => {
                                          if (e.target.value !== '') {
                                            setFilterRename(e.target.value);
                                          } else {
                                            setFilterRename('');
                                            setFilterRenameValid(true);
                                          }
                                        }}
                                        error={!isFilterRenameValid}
                                        helperText={
                                          !isFilterRenameValid && 'Required field missing'
                                        }
                                      />
                                    </DialogContent>
                                    <DialogActions>
                                      <Button
                                        onClick={async () => {
                                          if (filterRename.trim() === '') {
                                            setFilterRenameValid(false);
                                          } else {
                                            // Perform your save action here
                                            setAnchorEl(null);

                                            const filterObj = {
                                              id: filterSelectedUpdate[0]?.id,
                                              filterName: filterRename,
                                              userId: loggedInUserData?.id,
                                            };

                                            const result = await updateFilterName(filterObj);

                                            if (result) {
                                              handleMenuClose();
                                              result.duplicate && setShowSnackBarErr(true);
                                            }

                                            handleCloseFilterRename();
                                          }
                                        }}
                                        color="primary"
                                        variant="contained"
                                        autoFocus
                                      >
                                        Save
                                      </Button>
                                      <Button
                                        onClick={handleCloseFilterRename}
                                        className={classes.secondaryBtnUI}
                                        variant="outlined"
                                        color="secondary"
                                      >
                                        Cancel
                                      </Button>
                                    </DialogActions>
                                  </Dialog>

                                  <Dialog
                                    open={openFilterValidation}
                                    onClose={handleCloseFilterValidation}
                                    className={classes.SmallDialog}
                                    fullScreen={fullScreen}
                                    aria-labelledby="responsive-dialog-title"
                                  >
                                    <DialogTitle
                                      className={classes.dialogTitle}
                                      id="responsive-dialog-title"
                                    >
                                      <Typography variant="h4" component="span">
                                        Please select at least one metric to save the search
                                      </Typography>
                                      <IconButton
                                        aria-label="close"
                                        onClick={handleCloseFilterValidation}
                                      >
                                        <CloseIcon />
                                      </IconButton>
                                    </DialogTitle>

                                    <DialogActions>
                                      <Button
                                        onClick={handleCloseFilterValidation}
                                        color="primary"
                                        variant="contained"
                                        autoFocus
                                      >
                                        OK
                                      </Button>
                                    </DialogActions>
                                  </Dialog>

                                  <DeleteOption
                                    message={
                                      selectedSearchId
                                        ? DELETE_SAVED_SEARCH_WARNING
                                        : ALL_SAVED_SEARCH_WARNING
                                    }
                                    openDeleteDialog={openDeleteConfirmation}
                                    fullScreen={fullScreen}
                                    onClickYes={() => {
                                      handleDeleteSavedSearches(
                                        { resetForm },
                                        selectedSearchId ? false : true,
                                      );
                                    }}
                                    handleClose={() => {
                                      closeDeleteConfirmation();
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Box>

                          <Grid item xs={12} sm={12} md={12}>
                            <Box className={classes.innercontentWhite} style={{ height: '100%' }}>
                              <Grid container spacing={2}>
                                <Grid item xs={9}>
                                  <Grid container spacing={2} onClick={handleOutsideClick}>
                                    <If
                                      condition={
                                        savedSearches &&
                                        savedSearches.length > 0 &&
                                        savedSearches !== 'No Data'
                                      }
                                    >
                                      {' '}
                                      {Array.isArray(savedSearches) && savedSearches.length > 0
                                        ? savedSearches.map((entry, index) => (
                                            <Grid item key={entry.id}>
                                              <div className={classes.TableInnerFilter}>
                                                <Button
                                                  variant="outlined"
                                                  onClick={async (event) => {
                                                    values = await handleSearchButtonClick(
                                                      event,
                                                      index,
                                                      entry?.id,
                                                      values,
                                                      'button',
                                                      { resetForm },
                                                    );
                                                  }}
                                                  id={`button-${index}`} // Add id attribute with index value
                                                >
                                                  {entry.filterName}
                                                </Button>
                                                <Button
                                                  variant="outlined"
                                                  disabled={selectedSearchId !== entry.id}
                                                  onClick={(event) => {
                                                    setSearchAnchorEl(event.currentTarget);
                                                    handleSearchButtonClick(
                                                      event,
                                                      index,
                                                      entry?.id,
                                                      values,
                                                      'arrow',
                                                      { resetForm },
                                                    );
                                                  }}
                                                  id={`buttonArrow-${index}`}
                                                >
                                                  <KeyboardArrowDownIcon />
                                                </Button>
                                              </div>

                                              <Popover
                                                className={classes.MoreOptionsV2}
                                                id={`menu-${index}`}
                                                anchorEl={searchAnchorEl}
                                                open={Boolean(
                                                  searchAnchorEl &&
                                                    searchAnchorEl.id === `buttonArrow-${index}`,
                                                )}
                                                onClose={handleMenuClose}
                                                anchorOrigin={{
                                                  vertical: 'bottom',
                                                  horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                  vertical: 'top',
                                                  horizontal: 'right',
                                                }}
                                              >
                                                <MenuItem
                                                  onClick={() => {
                                                    setFilterRenameValid(true);
                                                    handleRenameButton(entry?.id);
                                                  }}
                                                >
                                                  Edit Name
                                                </MenuItem>

                                                <MenuItem
                                                  onClick={() => {
                                                    openDeleteConfirmationBox(entry?.id);
                                                  }}
                                                >
                                                  Delete Search
                                                </MenuItem>
                                              </Popover>
                                            </Grid>
                                          ))
                                        : null}
                                    </If>
                                  </Grid>
                                </Grid>
                                <Grid item xs={3} container justify="flex-end">
                                  <Box display="flex" alignItems="center">
                                    <Box display="flex" mr={3}>
                                      <FormControlLabel
                                        value="Edit Mode"
                                        control={
                                          <Switch
                                            disabled={
                                              selectedSearchIndex == null || !isApplyClicked
                                            }
                                            color="primary"
                                            size="small"
                                            title="Edit current search or start a new search tab "
                                            checked={filterEditMode}
                                            onChange={handleEditMode}
                                          />
                                        }
                                        label="Edit Mode "
                                        labelPlacement="start"
                                      />
                                    </Box>
                                    <Button
                                      type="submit"
                                      className={classes.button}
                                      disabled={
                                        !isApplyClicked &&
                                        (filteredFpData.length == 0 ||
                                          filteredFpDataClone.length == 0)
                                      }
                                      variant="outlined"
                                      onClick={async () => {
                                        if (filterEditMode) {
                                          setFilterNameValid(false);
                                          setFilterSubmitted(values);
                                          if (
                                            values['yearid'] &&
                                            values['fieldoptionid'] &&
                                            selectedSearchId
                                          ) {
                                            const filterObj = {
                                              id: selectedSearchId,
                                              metrics: values['fieldoptionid'] || [],
                                              country: values['countryid'] || [],
                                              cell: values['cellid'] || [],
                                              department: values['deptid'] || [],
                                              year: values['yearid'] || '',
                                              period: values['period'] || [],
                                            };
                                            const result = await updateSavedFilter(filterObj);
                                            if (result) {
                                              loadAllFilters();
                                              handleMenuClose();
                                            }
                                          } else {
                                            setOpenFilterValidation(true);
                                          }
                                        } else {
                                          if (values['yearid'] === undefined) {
                                            values['yearid'] =
                                              yearListForFilter.length > 0
                                                ? yearListForFilter[yearListForFilter.length - 1]
                                                    ?.id
                                                : '';
                                            setSelectedYear(values['yearid']);
                                          }

                                          if (values['yearid'] && values['fieldoptionid']) {
                                            setFilterNameValid(true);
                                            setOpenFilterName(true);
                                          } else {
                                            setOpenFilterValidation(true);
                                          }
                                        }

                                        handleClose();
                                      }}
                                    >
                                      {filterEditMode ? 'Save Changes' : 'Save Search'}
                                    </Button>
                                  </Box>
                                </Grid>
                              </Grid>
                              <Box>
                                <Grid container spacing={2}>
                                  <Grid item xs={10}>
                                    <Typography variant="h5">
                                      {Object.entries(cellsByCountryIndicator).length > 0 && '- '}
                                      {((selectedCountryOption.length > 0 &&
                                        selectedCountryOption.length === countryList.length &&
                                        selectedFieldOption.length > 0 &&
                                        selectedCellOption.length == 0 &&
                                        selectedDepartmentOption.length == 0) ||
                                        (selectedCountryOption.length == 0 &&
                                          selectedFieldOption.length > 0 &&
                                          selectedCellOption.length == 0 &&
                                          selectedDepartmentOption.length > 0 &&
                                          selectedDepartmentOption.length ===
                                            deptListForFilter.length)) && <>[ All Vector ] </>}
                                      {!(
                                        selectedCountryOption.length > 0 &&
                                        selectedCountryOption.length === countryList.length
                                      ) &&
                                        Object.entries(cellsByCountryIndicator).length == 0 &&
                                        values?.countryid &&
                                        values?.countryid.length > 0 &&
                                        values?.countryid.map((country, index) => {
                                          const countryObj = isValidJSON(country)
                                            ? JSON.parse(country)
                                            : country;
                                          return (
                                            <span key={countryObj.id}>
                                              {countryObj.countryTitle}{' '}
                                              {index < values?.countryid.length - 1 && ', '}
                                            </span>
                                          );
                                        })}
                                      {Object.entries(cellsByCountryIndicator).map(
                                        ([country, cells], index, array) => (
                                          <React.Fragment key={country}>
                                            {country}{' '}
                                            {selectedCellOption.length <
                                              cellListForFilter.length && (
                                              <>
                                                {' '}
                                                <span style={{ fontWeight: '500' }}>
                                                  [ Cells {Array.from(cells).join(', ')} ]
                                                </span>
                                                {index !== array.length - 1 && ' '}
                                              </>
                                            )}
                                          </React.Fragment>
                                        ),
                                      )}
                                      {selectedCellOption.length > 0 &&
                                        selectedCellOption.length === cellListForFilter.length && (
                                          <>
                                            <span style={{ fontWeight: '500' }}>[All Cells]</span>{' '}
                                          </>
                                        )}
                                      {values?.deptid &&
                                        values?.deptid.length > 0 &&
                                        values?.deptid.map((dept, index) => {
                                          const deptObj = isValidJSON(dept)
                                            ? JSON.parse(dept)
                                            : dept;
                                          return (
                                            selectedDepartmentOption.length > 0 &&
                                            selectedDepartmentOption.length <
                                              deptListForFilter.length && (
                                              <>
                                                <span
                                                  style={{ fontWeight: '500' }}
                                                  key={deptObj.id}
                                                >
                                                  {index == 0 && '[ '}
                                                  {deptObj.department}
                                                  {index < values?.deptid.length - 1 && ', '}
                                                  {values?.deptid.length - 1 == index && ' ]'}
                                                </span>
                                              </>
                                            )
                                          );
                                        })}
                                      {selectedDepartmentOption.length > 0 &&
                                        selectedDepartmentOption.length ===
                                          deptListForFilter.length && (
                                          <>
                                            <span style={{ fontWeight: '500' }}>
                                              [All Departments]
                                            </span>{' '}
                                          </>
                                        )}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={2}>
                                    <ClickAwayListener onClickAway={handleClose}>
                                      <Box
                                        display="flex"
                                        justifyContent="center"
                                        className={classes.ThreeDotSearch}
                                      >
                                        <MoreVertIcon
                                          onClick={(event) => {
                                            setAnchorEl(event.currentTarget);
                                          }}
                                          className={classes.MoreOptionsIcon}
                                        />
                                        <Popover
                                          id="simple-menu"
                                          anchorEl={anchorEl}
                                          open={Boolean(anchorEl)}
                                          onClose={handleClose}
                                          className={classes.MoreOptionsV2}
                                          anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                          }}
                                          transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                          }}
                                        >
                                          <MenuItem
                                            onClick={() => {
                                              handleFocusModeClick();
                                              handleSubmenuClose();
                                              handleClose();
                                            }}
                                          >
                                            Focus Mode
                                          </MenuItem>
                                          <MenuItem
                                            disabled={
                                              filteredFpData.length == 0 ||
                                              hiddenColumns.length == 0
                                            }
                                            onClick={() => {
                                              handleToggleColumn();
                                              handleSubmenuClose();
                                              handleClose();
                                            }}
                                          >
                                            Unhide Columns
                                          </MenuItem>
                                          <MenuItem
                                            disabled={savedSearches.length == 0}
                                            onClick={openDeleteConfirmationBox}
                                          >
                                            Delete Saved Searches
                                          </MenuItem>
                                        </Popover>
                                      </Box>
                                    </ClickAwayListener>
                                  </Grid>
                                </Grid>
                              </Box>

                              <If condition={filteredFpData.length > 0}>
                                <Box className={classes.materialDTNewStyle}>
                                  <div
                                    style={{
                                      boxShadow: 'none',
                                      overflowX: 'auto',
                                      maxHeight: '600px',
                                      overflowY: 'auto',
                                    }}
                                  >
                                    <table
                                      className={classes.materialDT}
                                      cellPadding="0"
                                      cellSpacing="0"
                                      style={{ minWidth: '1200px' }}
                                    >
                                      {(() => {
                                        const visibleColumns = filteredColumnList.filter(
                                          (column) => !column.hidden,
                                        );

                                        // Define specific widths for each column type
                                        const getColumnWidth = (field) => {
                                          switch (field) {
                                            case 'ranking':
                                              return '120px';
                                            case 'name':
                                              return '180px';
                                            case 'country':
                                              return '130px';
                                            case 'cell':
                                              return '120px';
                                            case 'department':
                                              return '150px';
                                            case 'salary':
                                              return '110px';
                                            case 'bonuses':
                                              return '110px';
                                            case 'commissions':
                                              return '110px';
                                            case 'benefits':
                                              return '110px';
                                            case 'expenseReport':
                                              return '110px';
                                            case 'total':
                                              return '100px';
                                            default:
                                              return 'auto';
                                          }
                                        };

                                        return (
                                          <>
                                            <colgroup>
                                              {Array.isArray(visibleColumns)
                                                ? visibleColumns.map((column, index) => (
                                                    <col
                                                      key={index}
                                                      style={{
                                                        width: getColumnWidth(column.field),
                                                      }}
                                                    />
                                                  ))
                                                : null}
                                            </colgroup>
                                            <thead>{renderHeader()}</thead>

                                            <tbody>
                                              {Array.isArray(displayedFpData)
                                                ? displayedFpData.map((rowData, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                      {Array.isArray(visibleColumns)
                                                        ? visibleColumns.map((column, colIndex) => {
                                                            let content;
                                                            if (column.field === 'ranking') {
                                                              const rankData =
                                                                rowData[column.field];
                                                              const displayRank =
                                                                rankData &&
                                                                typeof rankData === 'object' &&
                                                                'rankValue' in rankData
                                                                  ? rankData.rankValue
                                                                  : rankData;
                                                              content = (
                                                                <Box
                                                                  display="flex"
                                                                  justifyContent="center"
                                                                >
                                                                  <span
                                                                    className={
                                                                      displayRank === 1
                                                                        ? classes.vectorRankingGreen
                                                                        : displayRank ===
                                                                          filteredFpData.length
                                                                        ? classes.vectorRankingRed
                                                                        : classes.vectorranking
                                                                    }
                                                                  >
                                                                    {displayRank}
                                                                  </span>
                                                                </Box>
                                                              );
                                                            } else if (column.field === 'name') {
                                                              content = (
                                                                <span
                                                                  key={colIndex}
                                                                  onClick={() =>
                                                                    redirectPage(rowData)
                                                                  }
                                                                >
                                                                  {rowData[column.field]}
                                                                </span>
                                                              );
                                                            } else if (
                                                              [
                                                                'salary',
                                                                'commissions',
                                                                'bonuses',
                                                                'benefits',
                                                                'expenseReport',
                                                                'total',
                                                              ].includes(column.field)
                                                            ) {
                                                              const value = rowData[column.field];
                                                              content = (
                                                                <span key={colIndex}>
                                                                  {formatToCurrency(value, classes)}
                                                                </span>
                                                              );
                                                            } else {
                                                              // For fields like "cell", "country", "department" etc., render the raw value
                                                              content = rowData[column.field];
                                                            }

                                                            return (
                                                              <td key={colIndex}>{content}</td>
                                                            );
                                                          })
                                                        : null}
                                                    </tr>
                                                  ))
                                                : null}
                                            </tbody>

                                            <tfoot>
                                              <tr
                                                style={{
                                                  fontWeight: 'bold',
                                                  fontSize: '12px',
                                                  backgroundColor: '#bac6d3',
                                                }}
                                              >
                                                {Array.isArray(visibleColumns)
                                                  ? visibleColumns.map((column) => {
                                                      let value = null;
                                                      switch (column.field) {
                                                        case 'salary':
                                                          value = totals?.salary;
                                                          break;
                                                        case 'commissions':
                                                          value = totals?.commissions;
                                                          break;
                                                        case 'bonuses':
                                                          value = totals?.bonuses;
                                                          break;
                                                        case 'benefits':
                                                          value = totals?.benefits;
                                                          break;
                                                        case 'expenseReport':
                                                          value = totals?.expenseReport;
                                                          break;
                                                        case 'name':
                                                          value = 'Total';
                                                          break;
                                                        case 'total':
                                                          value = totals?.total;
                                                          break;
                                                        default:
                                                          value = null;
                                                      }
                                                      return (
                                                        <td
                                                          key={column.field}
                                                          style={{
                                                            cursor: 'default',
                                                            fontWeight: 'bold',
                                                          }}
                                                        >
                                                          {value === 'Total'
                                                            ? 'Overall Total'
                                                            : value
                                                            ? formatToCurrency(value, classes)
                                                            : [
                                                                'salary',
                                                                'commissions',
                                                                'bonuses',
                                                                'benefits',
                                                                'expenseReport',
                                                                'total',
                                                              ].includes(column.field)
                                                            ? '$0'
                                                            : null}
                                                        </td>
                                                      );
                                                    })
                                                  : null}
                                              </tr>
                                            </tfoot>
                                          </>
                                        );
                                      })()}
                                    </table>
                                  </div>
                                </Box>
                              </If>

                              <If condition={filteredFpData.length === 0}>
                                <div style={containerStyle}>
                                  <If
                                    condition={
                                      isApplyClicked ||
                                      (!isApplyClicked &&
                                        selectedSearchId &&
                                        filteredFpData.length == 0)
                                    }
                                  >
                                    <Box py={2}>
                                      {' '}
                                      {!loaded ? (
                                        ''
                                      ) : (
                                        <Typography>
                                          {!values?.fieldoptionid
                                            ? 'Hmmm... Sorry, select metric and countries or departments to see the results '
                                            : values?.fieldoptionid &&
                                              values?.countryid &&
                                              values?.countryid.length == 0 &&
                                              (!values?.deptid || values?.deptid.length == 0)
                                            ? 'Hmmm... Sorry, select countries or departments to see the results for '
                                            : "Hmmm... Sorry, we couldn't find any matches for "}
                                          {values?.fieldoptionid &&
                                            values.fieldoptionid
                                              .map((val) =>
                                                val
                                                  .replace(/([a-z])([A-Z])/g, '$1 $2')
                                                  .toLowerCase(),
                                              )
                                              .map((s) => s[0].toUpperCase() + s.slice(1))
                                              .join(', ')}
                                          {' in  '}
                                          {!values?.yearid
                                            ? new Date().getFullYear()
                                            : yearListForFilter[Number(values?.yearid) - 1]
                                                ?.year}{' '}
                                          {values?.yearid && ' Year '}
                                          {values?.yearid &&
                                          values?.period &&
                                          values?.countryid &&
                                          values?.countryid.length > 0
                                            ? ', '
                                            : ''}
                                          {((selectedCountryOption.length > 0 &&
                                            selectedCountryOption.length === countryList.length &&
                                            selectedFieldOption.length > 0 &&
                                            selectedCellOption.length == 0 &&
                                            selectedDepartmentOption.length == 0) ||
                                            (selectedCountryOption.length == 0 &&
                                              selectedFieldOption.length > 0 &&
                                              selectedCellOption.length == 0 &&
                                              selectedDepartmentOption.length > 0 &&
                                              selectedDepartmentOption.length ===
                                                deptListForFilter.length)) && <>[ All Vector ] </>}
                                          {!(
                                            selectedCountryOption.length > 0 &&
                                            selectedCountryOption.length === countryList.length
                                          ) &&
                                            Object.entries(cellsByCountryIndicator).length == 0 &&
                                            values?.countryid &&
                                            values?.countryid.length > 0 &&
                                            values?.countryid.map((country, index) => {
                                              const countryObj = isValidJSON(country)
                                                ? JSON.parse(country)
                                                : country;
                                              return (
                                                <span key={countryObj.id}>
                                                  {countryObj.countryTitle}
                                                  {index < values?.countryid.length - 1 && ', '}
                                                </span>
                                              );
                                            })}
                                          {Object.entries(cellsByCountryIndicator).map(
                                            ([country, cells], index, array) => (
                                              <React.Fragment key={country}>
                                                {country}{' '}
                                                {selectedCellOption.length <
                                                  cellListForFilter.length && (
                                                  <>
                                                    {' '}
                                                    <span style={{ fontWeight: '500' }}>
                                                      [ Cells {Array.from(cells).join(', ')} ]
                                                    </span>
                                                    {index !== array.length - 1 && ' '}
                                                  </>
                                                )}
                                              </React.Fragment>
                                            ),
                                          )}
                                          {selectedCellOption.length > 0 &&
                                            selectedCellOption.length ===
                                              cellListForFilter.length && (
                                              <>
                                                <span style={{ fontWeight: '500' }}>
                                                  [All Cells]
                                                </span>{' '}
                                              </>
                                            )}
                                          {values?.deptid &&
                                            values?.deptid.length > 0 &&
                                            values?.deptid.map((dept, index) => {
                                              const deptObj = isValidJSON(dept)
                                                ? JSON.parse(dept)
                                                : dept;
                                              return (
                                                selectedDepartmentOption.length > 0 &&
                                                selectedDepartmentOption.length <
                                                  deptListForFilter.length && (
                                                  <>
                                                    <span
                                                      style={{ fontWeight: '500' }}
                                                      key={deptObj.id}
                                                    >
                                                      {index == 0 && '[ '}
                                                      {deptObj.department}
                                                      {index < values?.deptid.length - 1 && ', '}
                                                      {values?.deptid.length - 1 == index && ' ]'}
                                                    </span>
                                                  </>
                                                )
                                              );
                                            })}
                                          {selectedDepartmentOption.length > 0 &&
                                            selectedDepartmentOption.length ===
                                              deptListForFilter.length && (
                                              <>
                                                <span style={{ fontWeight: '500' }}>
                                                  [All Departments]
                                                </span>{' '}
                                              </>
                                            )}
                                          .{' '}
                                          {values?.fieldoptionid &&
                                            'Please try different search term.'}
                                        </Typography>
                                      )}
                                    </Box>
                                  </If>
                                  <If condition={values?.fieldoptionid && !isApplyClicked}>
                                    <Box mb={3}>
                                      <Typography variant="h2">
                                        Select a metric to view data
                                      </Typography>
                                    </Box>
                                    <img src={blankIMage} alt="Blank Image" style={imageStyle} />
                                    <Box mb={5}></Box>
                                  </If>
                                  <If condition={!values?.fieldoptionid}>
                                    <Box mb={3}>
                                      <Typography variant="h2">
                                        Select a metric to view data
                                      </Typography>
                                    </Box>
                                    <img src={blankIMage} alt="Blank Image" style={imageStyle} />
                                    <Box mb={5}></Box>
                                  </If>
                                </div>
                              </If>
                              <div className={classes.tableFooter}>
                                <div>
                                  <span style={{ marginRight: '10px' }}>Rows per page:</span>

                                  <FormControl>
                                    <Box>
                                      <Select
                                        labelId="demo-simple-select-filled-label"
                                        value={pageFpSize}
                                        onChange={handleFpPageSizeChange}
                                        disableUnderline
                                      >
                                        {pageFpSizeOptions.map((size) => (
                                          <MenuItem key={size} value={size}>
                                            {size}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </Box>
                                  </FormControl>
                                </div>
                                <div className={classes.footerArrowSection}>
                                  <span>{`${startFpIndex + 1}-${
                                    endFpIndex >= filteredFpData.length
                                      ? filteredFpData.length
                                      : endFpIndex
                                  } of ${filteredFpData.length}`}</span>
                                  <button
                                    disabled={currentFpPage === 1}
                                    onClick={() => handleFpPageChange(currentFpPage - 1)}
                                  >
                                    <ChevronLeftIcon />
                                  </button>
                                  <button
                                    disabled={endFpIndex >= filteredFpData.length}
                                    onClick={() => handleFpPageChange(currentFpPage + 1)}
                                  >
                                    <ChevronRightIcon />
                                  </button>
                                </div>
                              </div>
                            </Box>
                          </Grid>
                        </>
                      );
                    }}
                  </Formik>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Snackbar open={showSnackBarErr} autoHideDuration={6000} onClose={handleSnackBarClose}>
              <Alert elevation={6} variant="filled" onClose={handleSnackBarClose} severity="error">
                The provided search name already exists.
              </Alert>
            </Snackbar>
          </Grid>

          <Grid item xs={12}></Grid>
        </Grid>
      </If>
      <If condition={!isFinAnalysisVisible}>
        <Box py={2}>
          <Box className={classes.innercontentWhite}>
            <Typography variant="body2">This section is not permitted</Typography>
          </Box>
        </Box>
      </If>
    </>
  );
};

export default FinancialAnalysisTab;
